import {
  Box,
  Flex,
  Text,
  Icon,
  VStack,
  Button,
  SimpleGrid,
  Card,
  CardBody,
  Badge,
} from "@chakra-ui/react";
import { FiMessageCircle, FiSend, FiBell, FiMail, FiSmartphone } from "react-icons/fi";
import { MdForum } from "react-icons/md";
import BreadCrumbMaker from "../../components/BreadCrumbMaker";
import { Link } from "react-router-dom";

const Communication = () => {
  const communicationModules = [
    {
      id: 1,
      title: "Chat",
      description: "Real-time messaging with drivers, vendors, and customers",
      icon: FiMessageCircle,
      link: "/communication/chat",
      bgColor: "#E7EDFF",
      color: "#396AFF",
      status: "active",
    },
    {
      id: 2,
      title: "Notifications",
      description: "Manage push notifications and in-app alerts",
      icon: FiBell,
      link: "/communication/notifications",
      bgColor: "#FFF5D9",
      color: "#FFBB38",
      status: "coming-soon",
    },
    {
      id: 3,
      title: "SMS",
      description: "Send SMS messages to drivers and customers",
      icon: FiSmartphone,
      link: "/communication/sms",
      bgColor: "#DCFAF8",
      color: "#00B69B",
      status: "coming-soon",
    },
    {
      id: 4,
      title: "Email",
      description: "Email communication and templates management",
      icon: FiMail,
      link: "/communication/email",
      bgColor: "#FFE0EB",
      color: "#FF82AC",
      status: "coming-soon",
    },
    {
      id: 5,
      title: "Broadcast",
      description: "Send bulk messages to multiple recipients",
      icon: FiSend,
      link: "/communication/broadcast",
      bgColor: "#ffe9e2",
      color: "#ff8542",
      status: "coming-soon",
    },
  ];

  return (
    <Box px={4} py={6}>
      <BreadCrumbMaker items={[{ link: "#", title: "Communication", on: true }]} />
      
      <Box bg="white" borderRadius="2xl" p={6} shadow="sm">
        <Flex align="center" gap={3} mb={6}>
          <Flex
            bg="blue.100"
            borderRadius="full"
            p={3}
          >
            <Icon as={MdForum} boxSize={6} color="blue.600" />
          </Flex>
          <VStack align="flex-start" spacing={0}>
            <Text fontSize="xl" fontWeight="bold" color="gray.700">
              Communication Center
            </Text>
            <Text fontSize="sm" color="gray.500">
              Manage all your communication channels in one place
            </Text>
          </VStack>
        </Flex>

        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
          {communicationModules.map((module) => (
            <Card 
              key={module.id} 
              variant="outline" 
              _hover={{ shadow: "md", borderColor: "blue.200" }}
              opacity={module.status === "coming-soon" ? 0.7 : 1}
              cursor={module.status === "active" ? "pointer" : "default"}
              as={module.status === "active" ? Link : "div"}
              to={module.status === "active" ? module.link : undefined}
            >
              <CardBody>
                <Flex direction="column" gap={3}>
                  <Flex justify="space-between" align="flex-start">
                    <Flex
                      bg={module.bgColor}
                      borderRadius="full"
                      p={3}
                    >
                      <Icon as={module.icon} boxSize={6} color={module.color} />
                    </Flex>
                    {module.status === "coming-soon" && (
                      <Badge colorScheme="orange" fontSize="xs">
                        Coming Soon
                      </Badge>
                    )}
                    {module.status === "active" && (
                      <Badge colorScheme="green" fontSize="xs">
                        Active
                      </Badge>
                    )}
                  </Flex>
                  <VStack align="flex-start" spacing={1}>
                    <Text fontWeight="semibold" color="gray.700">
                      {module.title}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      {module.description}
                    </Text>
                  </VStack>
                </Flex>
              </CardBody>
            </Card>
          ))}
        </SimpleGrid>
      </Box>
    </Box>
  );
};

export default Communication;
